import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useConfig } from '../../../utils/useConfig'; // Dodany import hooka konfiguracji

function EmptyNavBar() {
  // Pobieranie konfiguracji
  const config = useConfig();
  const { company, theme } = config;

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [scrolled, setScrolled] = useState(false);

  // Obsługa zmiany szerokości okna i scrollowania
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    const handleScroll = () => {
      const offset = window.scrollY;
      setScrolled(offset > 20);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isMobile = windowWidth <= 1024;

  return (
    <motion.div
      className={`sticky w-full top-0 z-40 ${scrolled ? 'shadow-md' : ''}`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div
        className={`w-full bg-white transition-all duration-200 ${
          scrolled ? 'py-2' : 'py-4'
        } bg-opacity-95 backdrop-blur-md`}
      >
        <div className="mx-auto px-4">
          <div className="flex items-center justify-center lg:justify-start">
            {/* Logo */}
            <Link to="/" className="flex items-center space-x-2 group">
              <motion.img
                src={company.logo}
                alt={`${company.name} Logo`}
                className={`${isMobile ? 'h-8 w-8' : 'h-10 w-10'}`}
                whileHover={{ rotate: 10, scale: 1.05 }}
                transition={{ duration: 0.2 }}
              />
              <h1
                className={`font-display uppercase font-bold tracking-wider text-gray-800 group-hover:text-${theme.colors.primary} transition-colors ${
                  isMobile ? 'text-lg' : 'text-2xl'
                }`}
                style={{
                  color: theme.colors.text,
                }}
              >
                {company.name}
              </h1>
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default EmptyNavBar;
